module.exports = __webpack_public_path__ + "media/images/icon__community@2x-950dbc0ff7f63c32a9ebd77d8ed2d276.png";